import { createClasses } from '@/theme/create-classes';

// ----------------------------------------------------------------------

export const fileThumbnailClasses = {
  root: createClasses('file__thumbnail__root'),
  img: createClasses('file__thumbnail__img'),
  icon: createClasses('file__thumbnail__icon'),
  removeBtn: createClasses('file__thumbnail__remove__button'),
  downloadBtn: createClasses('file__thumbnail__download__button'),
};
